import React, { useState } from "react";
import QuestionMark from "./QuestionMark";

const Info = ({ renderContent }) => {
  return (
    <div className="info-content">{renderContent()}</div>
  );
};

export default Info;
